import { FC } from 'react'
import { ConclusionObjectivePayment } from '../../../modules/objectivePayment/ConclusionObjectivePayment'
import { ConclusionOneOffPayment } from '../../../modules/appraisal/one-off-payment/ConclusionOneOffPayment'
import { ConclusionTargetCorrectionPayment } from '../../../modules/appraisal/target-correction-payment/ConclusionTargetCorrectionPayment'
import { FullObjectivePaymentFragment, FullOneOffPaymentFragment, ObjectiveDto, TargetCorrectionPaymentDto } from '../../../types'

interface MeetingStatusModalPaymentProps {
  objectives: ObjectiveDto[]
  oneOffPayment?: FullOneOffPaymentFragment
  objectivePayment?: FullObjectivePaymentFragment
  targetCorrectionPayment?: TargetCorrectionPaymentDto
}

export const MeetingStatusModalPayment: FC<MeetingStatusModalPaymentProps> = ({
  objectives,
  oneOffPayment,
  objectivePayment,
  targetCorrectionPayment,
}) => {
  return (
    <>
      <div className="fullWidth" data-e2e-payment-conclusion>
        {objectives.length > 0 && (
          <div data-testid="meeting-status-objective">
            <ConclusionObjectivePayment objectivesToBePaid={objectives} objectivePayment={objectivePayment} />
          </div>
        )}
        {!!oneOffPayment && !!oneOffPayment.resultAmount && (
          <div data-testid="meeting-status-oneoffpayment">
            <ConclusionOneOffPayment oneOffPayment={oneOffPayment} showInfo={false} showSpacer={!!objectives.length} />
          </div>
        )}
        {!!targetCorrectionPayment && (
          <div data-testid="meeting-status-target-correction">
            <ConclusionTargetCorrectionPayment targetCorrectionPayment={targetCorrectionPayment} showSpacer={false} />
          </div>
        )}
      </div>
    </>
  )
}
